var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.998,
    height: 60,
    viewBox: "0 0 49.998 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u8003\\u8BD5icon",
    transform: "translate(-201.934 -115.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10802",
    "data-name": "\\u8DEF\\u5F84 10802",
    d: "M251.932,153.739V120.585a4.814,4.814,0,0,0-4.813-4.815H206.747a4.814,4.814,0,0,0-4.681,3.692l-.02,2.752-.112,16.392v32.349a4.814,4.814,0,0,0,4.813,4.812H229.9c1.918,0,9.219-2.773,14.7-8.348C249.611,162.334,251.932,155.49,251.932,153.739Z",
    fill: "#d8dff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10803",
    "data-name": "\\u8DEF\\u5F84 10803",
    d: "M251.932,156.389v-9.878c-.305,12.163-11.415,11.9-14.655,15.14l6.731,4.971C248.222,162.343,251.932,157.863,251.932,156.389Z",
    fill: "#bfc9e0",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10804",
    "data-name": "\\u8DEF\\u5F84 10804",
    d: "M232.551,175.77h-9.878c12.163-.306,11.627-11.163,14.865-14.4l5.244,6.478C238.5,172.062,234.021,175.77,232.551,175.77Z",
    fill: "#bfc9e0",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10805",
    "data-name": "\\u8DEF\\u5F84 10805",
    d: "M251.932,154.9V153.05a7.038,7.038,0,0,1-7.034,7.041h-4.281a4.363,4.363,0,0,0-4.359,4.36v4.282a7.039,7.039,0,0,1-7.039,7.037h1.845a12.535,12.535,0,0,0,8.861-3.671l8.338-8.338A12.535,12.535,0,0,0,251.932,154.9Z",
    fill: "#bfc9e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_6915",
    "data-name": "\\u7EC4 6915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10828",
    "data-name": "\\u8DEF\\u5F84 10828",
    d: "M216.238,145.749h3.79a.425.425,0,0,0,.4-.428v-4.01a.425.425,0,0,0-.4-.428h-3.79a.425.425,0,0,0-.4.428v4.01A.445.445,0,0,0,216.238,145.749Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10829",
    "data-name": "\\u8DEF\\u5F84 10829",
    d: "M209.947,139.063h3.791a.425.425,0,0,0,.4-.426v-4.012a.424.424,0,0,0-.4-.426h-3.791a.424.424,0,0,0-.4.426v4.04A.4.4,0,0,0,209.947,139.063Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10830",
    "data-name": "\\u8DEF\\u5F84 10830",
    d: "M216.238,139.063h3.79a.425.425,0,0,0,.4-.426v-4.012a.423.423,0,0,0-.4-.426h-3.79a.424.424,0,0,0-.4.426v4.04A.417.417,0,0,0,216.238,139.063Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10831",
    "data-name": "\\u8DEF\\u5F84 10831",
    d: "M213.738,140.883h-3.791a.426.426,0,0,0-.4.428v4.01a.426.426,0,0,0,.4.428h3.791a.426.426,0,0,0,.4-.428v-4.01A.426.426,0,0,0,213.738,140.883Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10832",
    "data-name": "\\u8DEF\\u5F84 10832",
    d: "M222.559,145.749h3.788a.425.425,0,0,0,.4-.428v-4.01a.425.425,0,0,0-.4-.428h-3.791a.427.427,0,0,0-.4.428v4.01a.427.427,0,0,0,.4.428Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10833",
    "data-name": "\\u8DEF\\u5F84 10833",
    d: "M209.547,128.206v3.13a.382.382,0,0,0,.4.333h16.431a.387.387,0,0,0,.4-.333v-3.13a.388.388,0,0,0-.409-.333H209.947A.4.4,0,0,0,209.547,128.206Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10834",
    "data-name": "\\u8DEF\\u5F84 10834",
    d: "M222.556,139.063h3.791a.425.425,0,0,0,.4-.426v-4.012a.423.423,0,0,0-.4-.426h-3.791a.425.425,0,0,0-.4.426v4.04A.4.4,0,0,0,222.556,139.063Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_104",
    "data-name": "\\u8DEF\\u5F84 104",
    d: "M244.939,128.646l-3.96-3.4-3.8,3.4v-12.84h7.76Z",
    fill: "#ff6983"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExam);
export default __webpack_public_path__ + "static/media/exam.3bd51c3ed87db6377a9b7e4e208fb398.svg";
export { ForwardRef as ReactComponent };